import { createEvent } from "ics";

export function openhouseCalendar(
  title: string,
  event: { startDate?: string; endDate?: string; location?: string },
) {
  const start = new Date(event.startDate ?? "");
  const end = new Date(event.endDate ?? "");
  if (!Number.isFinite(start.getTime()) || !Number.isFinite(end.getTime()))
    return null;
  const utc = (date: Date): [number, number, number, number, number] => [
    date.getUTCFullYear(),
    date.getUTCMonth() + 1,
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
  ];
  return (
    createEvent({
      title,
      location: event.location,
      start: utc(start),
      end: utc(end),
      startInputType: "utc",
      endInputType: "utc",
    }).value ?? null
  );
}
